import React, { useState } from 'react';

interface MediaImageProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  fallbackSrc?: string;
}

const MediaImage: React.FC<MediaImageProps> = ({ 
  src, 
  alt, 
  className = '', 
  style = {}, 
  fallbackSrc = "assets/images/placeholder.png" 
}) => {
  const [currentSrc, setCurrentSrc] = useState(src);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = () => {
    console.warn(`Failed to load image: ${currentSrc}`);
    
    if (!hasError && fallbackSrc && currentSrc !== fallbackSrc) {
      console.log(`Trying fallback image: ${fallbackSrc}`);
      setCurrentSrc(fallbackSrc);
      setHasError(true);
    } else {
      console.error(`All image sources failed for: ${alt}`);
      setHasError(true);
    }
    setIsLoading(false);
  };

  const handleLoad = () => {
    console.log(`Successfully loaded image: ${currentSrc}`);
    setIsLoading(false);
    setHasError(false);
  };

  return (
    <div className="position-relative">
      <img
        src={currentSrc}
        alt={alt}
        className={`${className} ${isLoading ? 'opacity-50' : ''}`}
        style={style}
        onError={handleError}
        onLoad={handleLoad}
      />
      
      {isLoading && (
        <div className="position-absolute top-50 start-50 translate-middle">
          <div className="spinner-border spinner-border-sm text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      
      {hasError && currentSrc === fallbackSrc && (
        <div className="position-absolute top-50 start-50 translate-middle text-center">
          <i className="feather-image text-grey-400 font-lg"></i>
          <small className="d-block text-grey-400 mt-1">Image unavailable</small>
        </div>
      )}
    </div>
  );
};

export default MediaImage;